import { cn } from '@/lib/utils';

interface IndicadorAtualizacaoProps {
  /** Verdadeiro enquanto uma busca está em andamento. */
  buscando: boolean;
  className?: string;
}

/**
 * Sinaliza que a tela se atualiza sozinha.
 *
 * Sem isso o usuário não tem como saber que o dado é vivo, e continua
 * apertando F5 por precaução. O ponto pisca apenas durante a busca de fato —
 * um indicador que pulsa o tempo todo vira ruído e deixa de informar.
 */
export function IndicadorAtualizacao({ buscando, className }: IndicadorAtualizacaoProps) {
  return (
    <p
      className={cn('text-silenciado-texto flex items-center gap-1.5 text-xs', className)}
      // `polite` para não interromper leitor de tela a cada ciclo.
      aria-live="polite"
    >
      <span
        className={cn(
          'size-1.5 rounded-full transition-colors',
          buscando ? 'bg-marca animate-pulse' : 'bg-borda',
        )}
        aria-hidden="true"
      />
      {buscando ? 'Atualizando…' : 'Atualiza automaticamente'}
    </p>
  );
}
